import { clamp } from "./MathEx.js";
export class Vector3 {
    x;
    y;
    z;
    constructor(x, y, z) {
        this.x = x;
        this.y = y;
        this.z = z;
    }
    static get right() {
        return new Vector3(1, 0, 0);
    }
    static get left() {
        return new Vector3(-1, 0, 0);
    }
    static get forward() {
        return new Vector3(0, 0, 1);
    }
    static Zero() {
        return new Vector3(0, 0, 0);
    }
    static Dot(lhs, rhs) {
        return lhs.x * rhs.x + lhs.y * rhs.y + lhs.z * rhs.z;
    }
    static SqrDistance(a, b) {
        const dx = a.x - b.x;
        const dy = a.y - b.y;
        const dz = a.z - b.z;
        return dx * dx + dy * dy + dz * dz;
    }
    static Distance(a, b) {
        return Math.sqrt(Vector3.SqrDistance(a, b));
    }
    static Magnitude(a) {
        return Math.sqrt(Vector3.Dot(a, a));
    }
    static SqrMagnitude(a) {
        return Vector3.Dot(a, a);
    }
    static DivideByNum(v, d) {
        return new Vector3(v.x * (1 / d), v.y * (1 / d), v.z * (1 / d));
    }
    static MultiplyByNum(v, m) {
        return new Vector3(v.x * m, v.y * m, v.z * m);
    }
    static MultiplyQuaternionByVector3(q, v) {
        //Vector3DQuaternion++;
        //QuaternionD q1 = QuaternionD.Inverse(q);
        //QuaternionD qNode = new QuaternionD(v.x, v.y, v.z, 0);
        //qNode = q * qNode * q1;
        //return new Vector3D(qNode.x, qNode.y, qNode.z);
        const nw = /*q.w * v.w*/ -1 * q.x * v.x - q.y * v.y - q.z * v.z;
        const nx = q.w * v.x /*+ q.x * v.w*/ + q.y * v.z - q.z * v.y;
        const ny = q.w * v.y /*+ q.y * v.w*/ + q.z * v.x - q.x * v.z;
        const nz = q.w * v.z /*+ q.z * v.w*/ + q.x * v.y - q.y * v.x;
        return new Vector3(-nw * q.x + nx * q.w - ny * q.z + nz * q.y, -nw * q.y + ny * q.w - nz * q.x + nx * q.z, -nw * q.z + nz * q.w - nx * q.y + ny * q.x);
    }
    static Angle(from, to) {
        const fromN = Vector3.Magnitude(from);
        const toN = Vector3.Magnitude(to);
        if (fromN == 0 || toN == 0)
            return 0;
        const fromVN = Vector3.DivideByNum(from, fromN);
        const toVN = Vector3.DivideByNum(to, toN);
        const distance = Vector3.Distance(fromVN, toVN);
        if (distance < 0.5)
            return Math.asin(distance / 2) * 2;
        return Math.acos(clamp(Vector3.Dot(fromVN, toVN), -1, 1));
    }
    static SignedAngle(from, to, axis) {
        const num1 = Vector3.Angle(from, to);
        const num2 = from.y * to.z - from.z * to.y;
        const num3 = from.z * to.x - from.x * to.z;
        const num4 = from.x * to.y - from.y * to.x;
        const num5 = Math.sign(axis.x * num2 + axis.y * num3 + axis.z * num4);
        return num1 * num5;
    }
    static Cross(lhs, rhs) {
        return new Vector3(lhs.y * rhs.z - lhs.z * rhs.y, lhs.z * rhs.x - lhs.x * rhs.z, lhs.x * rhs.y - lhs.y * rhs.x);
    }
    static Up() {
        return new Vector3(0.0, 1.0, 0.0);
    }
    static Right() {
        return new Vector3(1.0, 0.0, 0.0);
    }
    static Forward(rightHandedSystem = false) {
        return new Vector3(0.0, 0.0, rightHandedSystem ? -1.0 : 1.0);
    }
    multiplyByFloat(a) {
        return new Vector3(this.x * a, this.y * a, this.z * a);
    }
    add(otherVector) {
        return new Vector3(this.x + otherVector.x, this.y + otherVector.y, this.z + otherVector.z);
    }
    subtract(otherVector) {
        return new Vector3(this.x - otherVector.x, this.y - otherVector.y, this.z - otherVector.z);
    }
    normalize() {
        const m = Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
        if (m > 0)
            return new Vector3(this.x / m, this.y / m, this.z / m);
        return this;
    }
}
